/// <reference path="WebService.ts" />

interface WebService
{
    transferFunds( installment:PaymentInstallment, completion:any ) : void ;
    processSessionPayout( sessionID:string, completion:any ) : void ;
    sessionTransactions( sessionID:string, completion:any ) : void ;
    refundTransaction( transactionID:string, completion:any ) : void ;
    setTransactionAction( dlTransactionID:string, action:string, completion:any ) : void ;
}

WebService.prototype.transferFunds = function( installment:PaymentInstallment, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/transfer-installment/" + installment.identifier;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( completion );
}

// Re-runs the payout step of one cash desk session: reconcile and, on match,
// generate the installment. A held ( review ) installment converges to
// pending when the session finally reconciles.
WebService.prototype.processSessionPayout = function( sessionID:string, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/process-session-payout/" + sessionID;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( completion );
}

// Per-transaction view of the payout reconcile of one session: the venue
// lines and the registered rows matched up, each entry carrying a status
// ( ok / refunded / amountMismatch / missingDL / missingVenue / noReference ).
WebService.prototype.sessionTransactions = function( sessionID:string, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/session-transactions/" + sessionID;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( completion );
}

// Payout disposition of one registered transaction of a held session:
// "pocket" keeps the money on the balance account out of the payout,
// "transfer" accepts it into the payout, "pending" undoes either.
WebService.prototype.setTransactionAction = function( dlTransactionID:string, action:string, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/transaction-action/" + dlTransactionID + "/" + action;
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( completion );
}

// Full refund of one Adyen payment ( mirrors the capture split ). The server
// refuses it when the session's payout is already transferred.
WebService.prototype.refundTransaction = function( transactionID:string, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/refund-transaction/" + transactionID;
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( completion );
}
